import { environment } from '../../../../environments/environment';

export const DEFAULT_AUTH_PAGE_LOGO =
  'assets/images/logos/TRANSMARTIME-LOGO-BLANCO.png';
export const DEFAULT_AUTH_PAGE_BACKGROUND = 'assets/images/login.png';

export function resolveAuthPageLogoUrl(): string {
  const logo = environment.branding.logo?.trim();
  return logo || DEFAULT_AUTH_PAGE_LOGO;
}

export function resolveAuthPageBackgroundUrl(): string {
  const bg = environment.branding.background?.trim();
  return bg || DEFAULT_AUTH_PAGE_BACKGROUND;
}
